import axios from "axios";
import API_URL from "../constants/Connection";
import {useTranslation} from "react-i18next";


export const usePublicApi = () => {
    const {i18n} = useTranslation();
    return axios.create({
        baseURL: API_URL,
        headers: {
            "Content-Type": "application/json",
            "Accept-Language": i18n.language
        },
    })
}

export const login = (api, username, password) => api.post("/token-auth", {username, password});

export const signup = (api, username, password) => api.post("/signup", {username, password});

export const getScoreboardQuizzes = (api) => api.get("/scoreboard");

